/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tl_Keys_HelpInputs */

const en_tl_keys_help = /** @type {(inputs: Tl_Keys_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Up and down arrows move between rows. Alt plus left or right arrow moves the bar, Alt plus Shift plus left or right changes the due date. Enter sets dates, Space opens the preview, Shift plus Enter opens the item.`)
};

const de_tl_keys_help = /** @type {(inputs: Tl_Keys_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pfeil hoch und runter wechseln die Zeile. Alt mit Pfeil links oder rechts verschiebt den Balken, Alt mit Umschalt und Pfeil links oder rechts ändert die Fälligkeit. Enter setzt Termine, Leertaste zeigt die Vorschau, Umschalt und Enter öffnet den Vorgang.`)
};

/**
* | output |
* | --- |
* | "Up and down arrows move between rows. Alt plus left or right arrow moves the bar, Alt plus Shift plus left or right changes the due date. Enter sets dates, S..." |
*
* @param {Tl_Keys_HelpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tl_keys_help = /** @type {((inputs?: Tl_Keys_HelpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tl_Keys_HelpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tl_keys_help(inputs)
	return en_tl_keys_help(inputs)
});